<template>
  <div class="repairdetail">
    <div class="heightoverflow">
      <div class="common">
        <div class="repair-title">
          <div>{{repair_info.repair_type_name}}<span>{{repair_info.status}}</span></div>
          <div><button @click="returnBtn">返回首页</button></div>
        </div>
        <div class="repair-describe">{{repair_info.repair_summary}}</div>
        <div class="repair-image">
          <img v-for="(image, image_key) in repair_info.image_array" :key="image_key" :src="image.image_url" @click="previewImage(image.image_url)">
        </div>
      </div>
      <div class="common">
        <div class="repair-title">报修信息</div>
        <div class="cell-row">
          <div class="row">当前房屋</div>
          <div class="row">{{repair_info.room}}</div>
        </div>
        <div class="cell-row">
          <div class="row">报事人</div>
          <div class="row">{{repair_info.repair_people_name}}</div>
        </div>
        <div class="cell-row">
          <div class="row">联系电话</div>
          <div class="row"><a :href="'tel:' + repair_info.repair_people_tel"><img class="phone" src="../../assets/images/phone.png"> {{repair_info.repair_people_tel}}</a></div>
        </div>
        <div class="cell-row">
          <div class="row">报修点定位</div>
          <div class="row">{{repair_info.local}}</div>
        </div>
        <div class="cell-row">
          <div class="row">预约时间</div>
          <div class="row" v-if="repair_info.order_time !== ''">{{repair_info.order_time}}</div>
          <div class="row" v-else>无预约时间</div>
        </div>
        <button class="repair-btn" v-if="this.repairkeeperlist.length == 0 && this.permission !== 'repair_keeper'" @click="toAssign(repair_info.repair_id, repair_info.create_time)">指派</button>
      </div>
      <div class="common" v-if="this.repairkeeperlist.length !== 0">
        <div class="repair-title">报修配置</div>
        <div class="cell-row">
          <div class="row">指派人</div>
          <div class="row">{{repair_info.create_member_name}}</div>
        </div>
        <div class="cell-row">
          <div class="row">指派时间</div>
          <div class="row">{{repair_info.repair_appoint}}</div>
        </div>
        <div class="cell-row">
          <div class="row">主维修员</div>
          <div class="row">{{pri_repairkeeper}}</div>
          <span class="blue" @click="editRepairkeeper">编辑</span>
        </div>
        <div class="cell-row">
          <div class="row">协同维修员</div>
          <div class="row">{{coo_repairkeeper}}</div>
          <span class="blue" @click="editRepairkeeper">编辑</span>
        </div>
        <div class="cell-row">
          <div class="row">指定时间</div>
          <div class="row">{{repair_info.appoint_time}}之前到达</div>
          <span class="blue" @click="editTime">编辑</span>
          <mt-datetime-picker ref="datePicker" type="datetime" v-model="pickerValue" @confirm="handleConfirm"></mt-datetime-picker>
        </div>
      </div>
      <div class="common" v-if="repair_info.clock_time === '' || repair_info.clock_time === 0 && this.repairkeeperlist.length !== 0 && this.clocksee == true && repair_info.status !== '已完成'">
        <div class="repair-title">打卡</div>
        <!-- 上传图片 -->
        <div class="uploadImg">
          <div class="uploadImgFile">
            <input class="uploadImg" @change="uploadFile" type="file">
          </div>
          <div class="uploadImgList" v-for="(image, image_key) in imageList" :key="image_key">
            <img class="img" :src="image" @click="previewImage(image)">
            <img class="del" @click="deleteImage(image_key)" src="../../assets/images/repairman-del.png">
          </div>
        </div>
        <button class="repair-btn" @click="RepairClock">打卡</button>
      </div>
      <div class="common" v-if="repair_info.clock_time !== '' && repair_info.clock_time !== 0">
        <div class="repair-title">打卡</div>
        <div class="finish-time">打卡时间  {{repair_info.clock_date}}</div>
        <div class="repair-image">
          <img v-for="(clock_image, clock_image_key) in repair_info.clock_image_array" :key="clock_image_key" :src="clock_image.clock_image_url" @click="previewImage(clock_image.clock_image_url)">
        </div>
      </div>
      <div class="common" v-if="repair_info.clock_time !== '' && repair_info.clock_time !== 0 && repair_info.status === '受理中'">
        <div class="repair-title">完成</div>
        <div class="uploadImg">
          <div class="uploadImgFile">
            <input class="uploadImg" @change="uploadFile" type="file">
          </div>
          <div class="uploadImgList" v-for="(image, image_key) in imageList" :key="image_key">
            <img class="img" :src="image" @click="previewImage(image)">
            <img class="del" @click="deleteImage(image_key)" src="../../assets/images/repairman-del.png">
          </div>
        </div>
        <div style="display: flex;">
          <button class="repair-btn" @click="repairFinished" style="width: 48%;">完成</button>
          <button class="repair-btn" @click="repairClose(repair_info.repair_id)" style="width: 48%;margin-left: auto;">无法完成</button>
        </div>
      </div>
      <div class="common" v-if="repair_info.finish_time !== '' && repair_info.finish_time !== 0">
        <div class="repair-title">完成</div>
        <div class="finish-time">完成时间  {{repair_info.finish_date}}</div>
        <div class="repair-image">
          <img v-for="(finish_image, finish_image_key) in repair_info.finish_image_array" :key="finish_image_key" :src="finish_image.finish_image_url" @click="previewImage(finish_image.finish_image_url)">
        </div>
      </div>
      <div class="common" v-if="repair_info.cannt_finish_time !== '' && repair_info.cannt_finish_time !== 0">
        <div class="repair-title">无法完成</div>
        <div>无法完成原因  {{repair_info.cannt_finish}}</div>
        <div class="cannt-finish-time">关闭时间 {{repair_info.cannt_finish_time}}</div>
      </div>
      <div class="common" v-if="repair_info.finish_time !== '' && repair_info.finish_time !== 0 && repair_info.return_status == 0 ">
        <div class="repair-title">回访</div>
        <div class="evaluate-textarea">
          <textarea v-model="return_content" placeholder="请输入回访内容"></textarea>
        </div>
        <button class="repair-btn" @click="repairReturn">回访</button>
      </div>
      <div class="common" v-if="repair_info.return_time !== '' && repair_info.return_time !== 0">
        <div class="repair-title">回访</div>
        <div>回访内容  {{repair_info.return_content}}</div>
        <div class="finish-time">回访时间 {{repair_info.return_time}}</div>
      </div>
      <div class="common">维修用料出库单<button class="addInvoice row" @click="addInvoice">添加</button></div>
      <div class="common" v-if="this.repairOperateList.length !== 0">
        <div class="repair-title">历史记录</div>
        <div class="cell-row repairoperate" v-for="(repairOperate, repairOperate_key) in repairOperateList" :key="repairOperate_key">
          <div class="row">{{repairOperate.create_date}} {{repairOperate.log}}</div>
        </div>
      </div>
    </div>
    <!-- 预览图片 -->
    <div class="previewimg" v-if="previewFile">
      <div @click="previewclose"></div>
      <img :src="previewimg">
    </div>
    <!-- 加载动画 -->
    <div class="loading" v-if="loading">
      <img src="../../assets/images/loading.gif">
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'RepairDetail',
  metaInfo: {
    title: '报修详情'
  },
  data () {
    return {
      loading: false, // 加载动画
      access_token: '', // tob access_token
      imageList: [], // 保存图片集合
      imageListId: [], // 选中的图片id
      repair_info: [],
      lng: '',
      lat: '',
      pickerValue: new Date(),
      repairkeeperlist: [], // 维修员列表
      pri_repairkeeperlist: [],
      pri_repairkeeper: '', // 主维修员
      coo_repairkeeperlist: [],
      coo_repairkeeper: '', // 协同维修员
      repairOperateList: [], // 历史记录
      clocksee: false, // 只有维修员可以看到打卡按钮
      passprirepairkeeperlist: [],
      passcoorepairkeeperlist: [],
      jsonarray: [],
      previewimg: '', // 预览图片
      previewFile: false, // 预览默认关闭
      maxSize: 500, // 上传图片限制最大为500kb
      formData: '',
      villageId2: '',
      repairId2: '',
      userId2: '',
      setTime2: '',
      orderTime2: '',
      permission2: '',
      openid2: '',
      appid2: '',
      cannt_finish: '', // 无法完成原因
      return_content: '' // 回访原因
    }
  },
  computed: {
    ...mapState(['villageId', 'repairId', 'userId', 'setTime', 'appointTime', 'warningTime', 'orderTime', 'permission', 'openid', 'appid', 'locationRange', 'usertel'])
  },
  created () {
    this.loading = true

    console.log(this.openid)
    // 通过链接获取信息
    var urll = window.location.href
    if (urll.indexOf('?') !== -1) {
      var str = urll.substr()
      var strs = str.split('?')
      var strs2 = strs[1].split('&')
      var objarray = []
      for (var i = 0; i < strs2.length; i++) {
        objarray.push(strs2[i])
      }
      for (var k = 0; k < objarray.length; k++) {
        // console.log(objarray[k].split('='))
        // console.log(objarray[k].split('=')[0])
        if (objarray[k].split('=')[0] === 'village_id') {
          this.villageId2 = objarray[k].split('=')[1]
        } else if (objarray[k].split('=')[0] === 'repair_id') {
          this.repairId2 = objarray[k].split('=')[1]
        } else if (objarray[k].split('=')[0] === 'village_member_id') {
          this.userId2 = objarray[k].split('=')[1]
        } else if (objarray[k].split('=')[0] === 'set_time') {
          this.setTime2 = objarray[k].split('=')[1]
        } else if (objarray[k].split('=')[0] === 'order_time') {
          this.orderTime2 = objarray[k].split('=')[1]
        } else if (objarray[k].split('=')[0] === 'permission') {
          this.permission2 = objarray[k].split('=')[1]
        } else if (objarray[k].split('=')[0] === 'openid') {
          this.openid2 = objarray[k].split('=')[1]
        } else if (objarray[k].split('=')[0] === 'authorizer_appid') {
          this.appid2 = objarray[k].split('=')[1]
        }
      }
      this.changeArgs({
        villageId: this.villageId2,
        repairId: this.repairId2,
        userId: this.userId2,
        setTime: this.setTime2,
        orderTime: this.orderTime2,
        permission: this.permission2,
        openid: this.openid2,
        appid: this.appid2
      })
    }
    if (this.openid === '') {
      this.$router.replace({name: 'Login', query: {appid: this.appid2}})
    }

    this.getAccessToken()
    this.getRepairInfo()
    this.updateRepirIsread()
    this.getRepairOperate()

    // 获取当前经纬度
    let that = this
    let url = window.location.href.split('#')[0]
    console.log(url)
    this.axios.post('/wechat/index/getticket', {
      url,
      village_id: this.villageId
    }).then((res) => {
      this.wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.data.data.appId, // 必填，公众号的唯一标识
        timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
        signature: res.data.data.signature, // 必填，签名
        jsApiList: ['getLocation'] // 必填，需要使用的JS接口列表 hideMenuItems
      })
      this.wx.ready(() => {
        // console.log('成功')
        this.wx.getLocation({
          type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: function (res) {
            // var latitude = res.latitude // 纬度，浮点数，范围为90 ~ -90
            // var longitude = res.longitude // 经度，浮点数，范围为180 ~ -180。
            // var speed = res.speed // 速度，以米/每秒计
            // var accuracy = res.accuracy // 位置精度
            that.lng = res.longitude
            that.lat = res.latitude
          }
        })
      })
      this.wx.error(function (res) {
        // console.log('失败')
      })
    })
  },
  methods: {
    ...mapMutations(['changeArgs']),
    // 选择上传图片
    uploadFile (e) {
      if (this.imageList.length < 9) {
        let that = this
        var files = e.target.files[0]

        var reader = new FileReader()
        reader.readAsDataURL(files)
        // 监听文件读取结束后事件
        reader.onloadend = function (e) {
          // var dx = (e.total / 1024) / 1024
          // if (dx >= 2) {
          //   alert('文件大小大于2M')
          //   return
          // }
          that.imageList.push(e.target.result)

          let img = new Image()
          img.src = reader.result
          img.onload = () => {
            // 以上是将选择的图片展示出来
            let originWidth = img.naturalWidth
            let originHeight = img.naturalHeight
            let originSize = e.total / 1024 // 计算图片多少kb
            // 将图片绘制到canvas上进行压缩
            let canvas = document.createElement('canvas')
            let context = canvas.getContext('2d')
            let maxSize = that.maxSize
            if (originSize <= maxSize) {
              that.formData = new FormData() // 声明一个FormData对象
              that.formData.append('file', files)
            } else {
              let mul = originSize / maxSize
              let targetWidth = originWidth / mul
              let targetHeight = originHeight / mul
              canvas.width = targetWidth
              canvas.height = targetHeight
              context.clearRect(0, 0, targetWidth, targetHeight) // 清除画布
              context.drawImage(img, 0, 0, targetWidth, targetHeight) // 画图

              let dataURL = canvas.toDataURL('image/jpeg') // 将其转化成base64字符串
              let blob = that.dataURItoBlob(dataURL) // 转化为blob格式
              var fileName = new Date().getTime() + '.jpeg'

              that.formData = new FormData() // 声明一个FormData对象
              that.formData.append('file', blob, fileName)
            }
            var options = { // 设置axios的参数
              url: '/api/Upload/uploadpicture?access_token=' + that.access_token,
              data: that.formData,
              method: 'post',
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
            that.axios(options).then((res) => {
              that.imageListId = that.imageListId.concat(res.data.data.id)
              console.log(that.imageListId)
            })
          }
        }
      } else {
        this.$toast({
          message: '最多选择9张图片',
          duration: 5000
        })
      }
      e.target.value = '' // 解决input type=file 同一个文件二次上传无效的问题
    },
    // base64格式转化为blob对象
    dataURItoBlob (dataURI) {
      let byteString = atob(dataURI.split(',')[1])
      let mimeString = dataURI
        .split(',')[0]
        .split(':')[1]
        .split(';')[0]
      let ab = new ArrayBuffer(byteString.length)
      let ia = new Uint8Array(ab)
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ab], { type: mimeString })
    },
    // 删除上传图片
    deleteImage (e) {
      this.imageList.splice(e, 1)
      this.imageListId.splice(e, 1)
    },
    // 预览图片
    previewImage (e) {
      this.previewFile = true
      this.previewimg = e
    },
    // 关闭预览
    previewclose () {
      this.previewFile = false
    },
    // 获取tob accessToken
    getAccessToken () {
      this.axios.get('/wechat/repair/tobAccessToken')
        .then((res) => {
          if (res.data.status === 1) {
            this.access_token = res.data.data.access_token
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
    },
    getRepairInfo () {
      this.axios.get('/wechat/repair/getRepairInfo/village_id/' + this.villageId + '/repair_id/' + this.repairId)
        .then((res) => {
          console.log()
          if (res.data.status === 1) {
            this.loading = false
            this.repair_info = res.data.data
            this.repairkeeperlist = res.data.data.repair_keeper_list
            this.changeArgs({setTime: res.data.data.set_time, appointTime: res.data.data.appoint_time, warningTime: res.data.data.repair_warning_time, orderTime: res.data.data.order_time})

            for (let i = 0; i < this.repairkeeperlist.length; i++) {
              if (this.repairkeeperlist[i].level === 1) {
                this.passprirepairkeeperlist = this.repairkeeperlist[i]
                this.pri_repairkeeperlist.push(this.repairkeeperlist[i].repair_keeper_name)
                this.pri_repairkeeper = this.pri_repairkeeperlist.join('/')
              } else {
                this.passcoorepairkeeperlist.push(this.repairkeeperlist[i])
                this.coo_repairkeeperlist.push(this.repairkeeperlist[i].repair_keeper_name)
                this.coo_repairkeeper = this.coo_repairkeeperlist.join('/')
              }

              // 判断维修员的名字，打卡按钮只有维修员可见
              if (this.repairkeeperlist[i].repair_keeper_id === JSON.parse(this.userId)) {
                this.clocksee = true
              }
            }
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
    },
    // 指派
    toAssign (repairid, createtime) {
      this.$router.push({name: 'SelectRepairman'})
      this.changeArgs({repairId: repairid, createTime: createtime})
    },
    // 打卡
    RepairClock () {
      // this.repair_info.latitude = '43.86651'
      // this.repair_info.longitude = '125.358048'
      if (this.repair_info.longitude === '0' && this.repair_info.latitude === '0') {
        if (this.repair_info.clock_image_state === 1) {
          if (this.imageListId.length === 0) {
            this.$toast({
              message: '请上传打卡图片',
              duration: 3000
            })
            return false
          }
          this.RepairClock_post()
        } else {
          this.RepairClock_post()
        }
      } else {
        var lat1 = this.lat
        var lng1 = this.lng
        var lat2 = this.repair_info.latitude
        var lng2 = this.repair_info.longitude
        var radLat1 = lat1 * Math.PI / 180.0
        var radLat2 = lat2 * Math.PI / 180.0
        var a = radLat1 - radLat2
        var b = lng1 * Math.PI / 180.0 - lng2 * Math.PI / 180.0
        var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)))
        s = s * 6378.137 // EARTH_RADIUS;
        s = Math.round(s * 10000) / 10000
        var distance = s.toFixed(2)
        console.log(distance)
        console.log(JSON.stringify(this.locationRange / 1000))
        if (distance <= JSON.stringify(this.locationRange / 1000)) {
          this.RepairClock_post()
        } else {
          if (this.imageListId.length === 0) {
            this.$messagebox({
              message: '您的定位未进入打卡范围，请上传打卡图片',
              closeOnClickModal: false,
              // showCancelButton: true,
              confirmButtonText: '确定'
            })
            return false
          }
          this.RepairClock_post()
        }
      }
    },
    // 打卡请求
    RepairClock_post () {
      let imageListId = this.imageListId.join(',')
      this.axios.post('/wechat/repair/RepairClock/', {
        village_id: this.villageId,
        repair_id: this.repairId,
        user_id: this.userId,
        image_id: imageListId,
        clock_longitude: this.lng,
        clock_latitude: this.lat
      })
        .then((res) => {
          if (res.data.status === 1) {
            this.$toast({
              message: res.data.data.message,
              duration: 3000
            })
            location.reload()
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
    },
    // 编辑维修员
    editRepairkeeper () {
      // 主维修员
      var id = this.passprirepairkeeperlist.repair_keeper_id
      var tel = this.passprirepairkeeperlist.repair_keeper_tel
      var name = this.passprirepairkeeperlist.repair_keeper_name
      var headportrait = this.passprirepairkeeperlist.head_portrait
      // 协同维修员
      var jsona = JSON.stringify(this.passcoorepairkeeperlist)
      var jsonb = jsona.replace(/"repair_keeper_id"/g, '"id"')
      var jsonc = jsonb.replace(/"repair_keeper_name"/g, '"village_member_name"')
      var jsond = jsonc.replace(/"repair_keeper_tel"/g, '"tel"')
      var jsone = JSON.parse(jsond)
      console.log(jsone)
      this.changeArgs({orderTime: this.appointTime})
      this.$router.push({name: 'Repairman', query: {id: id, tel: tel, name: name, head_portrait: headportrait, newarray: JSON.stringify(jsone)}})
    },
    // 编辑指定时间
    editTime () {
      this.$refs['datePicker'].open()
    },
    // 选择时间点击确定按钮
    handleConfirm (val) {
      let date = val
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hour = date.getHours()
      let minute = date.getMinutes()
      month = month > 9 ? month : '0' + month
      day = day > 9 ? day : '0' + day
      hour = hour > 9 ? hour : '0' + hour
      minute = minute > 9 ? minute : '0' + minute
      let resDate = year + '-' + month + '-' + day + ' ' + hour + ':' + minute
      // console.log(resDate)
      this.changeArgs({orderTime: resDate})

      this.axios.post('/wechat/repair/editAppointTime/', {
        village_id: this.villageId,
        repair_id: this.repairId,
        appoint_time: this.orderTime
      }).then((res) => {
        if (res.data.status === 1) {
          this.$toast({
            message: res.data.info,
            duration: 5000
          })
          location.reload()
        }
      }).catch(() => {
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    },
    // 历史记录
    getRepairOperate () {
      this.axios.get('/wechat/repair/getRepairOperate/village_id/' + this.villageId + '/repair_id/' + this.repairId)
        .then((res) => {
          if (res.data.status === 1) {
            this.repairOperateList = res.data.data
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
    },
    // 获得维修员已读或未读的状态
    updateRepirIsread () {
      this.axios.get('/wechat/index/updateRepirIsread/village_member_id/' + this.userId + '/repair_id/' + this.repairId)
        .then((res) => {
          if (res.data.status === 1) {
            console.log(res)
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
    },
    // 获取小区列表 判断是否登陆
    getVillageList () {
      this.axios.get('/wechat/index/getUserVillageList/openid/' + this.openid + '/tel/' + this.usertel + '/authorizer_appid/' + this.appid)
        .then((res) => {
          if (res.data.data === null) {
            this.$router.push({name: 'Account'})
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
    },
    // 完成按钮
    repairFinished () {
      if (this.repair_info.finish_image_state === 1) {
        if (this.imageListId.length === 0) {
          this.$toast({
            message: '请上传图片',
            duration: 3000
          })
          return false
        }
        this.repairFinished_post()
      } else {
        this.repairFinished_post()
      }
    },
    repairFinished_post () {
      let imageListId = this.imageListId.join(',')
      this.axios.post('/wechat/repair/repairFinished/', {
        village_id: this.villageId,
        repair_id: this.repairId,
        village_member_id: this.userId,
        image_id: imageListId
      })
        .then((res) => {
          if (res.data.status === 1) {
            this.$toast({
              message: res.data.data.message,
              duration: 5000
            })
            location.reload()
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
    },
    // 返回首页
    returnBtn () {
      this.$router.push({name: 'Index'})
    },
    // 维修耗材出库
    addInvoice () {
      var text = ''
      if (this.repair_info.repair_keeper_list.length > 0) {
        text = this.repair_info.repair_keeper_list[0]['repair_keeper_name']
      }
      var repairUid = this.repair_info.repair_uid + ' ' + text
      this.$router.push({name: 'SelecteGoods', query: {repair_id: this.repair_info.repair_id, repair_uid: repairUid, delivery_type_id: 9, title_info: '维修耗材出库记账'}})
    },
    // 无法完成
    repairClose: function (repairid) {
      this.$router.push({name: 'Reason'})
      this.changeArgs({repairId: repairid})
    },
    // 回访
    repairReturn () {
      let content = this.return_content
      if (content === '') {
        this.$toast({
          message: '请输入回访内容',
          duration: 3000
        })
        return false
      }
      this.axios.post('/wechat/repair/repairReturn', {
        village_member_id: this.userId,
        village_id: this.villageId,
        repair_id: this.repairId,
        content: content
      })
        .then((res) => {
          if (res.data.status === 1) {
            this.$toast({
              message: res.data.data.message,
              duration: 5000
            })
            location.reload()
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
    }
  }
}
</script>
<style scoped>
.repairdetail {
  background-color: #f6f6f6;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.heightoverflow {
  height: 100%;
  overflow-y: auto;
}
.repairdetail .repair-title {
  display: flex;
  margin-bottom: 7px;
  color: #000000;
  font-size: 18px;
  font-weight: bold;
}
.repairdetail .repair-title div:first-child {
  flex: 1;
}
.repairdetail .repair-title div span {
  color: #8c8c8c;
  padding-left: 10px;
  font-weight: initial;
}
.repairdetail .repair-title div span:last-child {
  font-size: 16px;
}

.repairdetail .repair-describe {
  color: #000000;
  font-size: 14px;
  line-height: 20px;
  margin: 12px 0 3px 0;
}
.repairdetail .repair-image{
  font-size: 0;
}
.repairdetail .repair-image img {
  width: 60px;
  height: 60px;
  padding: 9px 9px 0 0;
}
.repairdetail .repair-btn {
  width: 100%;
  height: 45px;
  background-color: #ff9a0a;
  border-radius: 4px;
  border: none;
  color: #ffffff;
  font-size: 16px;
  margin-top: 6px;
}
.repairdetail .repair-btn img {
  width: 17px;
  height: 17px;
  vertical-align: top;
  padding:0px 2px 8px 0 0;
}
.repairdetail .repair-title button {
  height: 25px;
  line-height: 24px;
  background-color: #ff7c12;
  border-radius: 3px;
  border: none;
  color: #ffffff;
  font-size: 14px;
  padding: 0 10px;
}
.repairoperate .row {
  display: initial;
}
.phone {
  width: 18px;
  height: 18px;
  vertical-align: top;
}
.blue {
  color: blue;
  padding-left: 10px;
  min-width: 30px;
}
a {
  color: #000;
  text-decoration: none;
}
.addInvoice{
  margin-left: 20px;
}
.evaluate-textarea {
  display: flex;
  font-size: 14px;
}
.evaluate-textarea textarea {
  flex: 1;
  background-color: #f6f6f6;
  border: none;
  padding: 10px;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Repair/RepairDetail.vue